module.exports = __webpack_public_path__ + "static/media/waterfall.d92445bd.mp3";